export const apiUrl = process.env.REACT_APP_API_URL === 'prod'
    ? 'https://whale-app-6o59b.ondigitalocean.app'
    : 'http://localhost:8000'